import _Vue from "vue";
import axios, {Axios} from "axios";
import app from "@/main";
import {Mixins} from "@/plugins/uyap-plugin/takip_ac/Mixins";
import * as xml2js from "xml2js";
import {PlayerDurum} from "@/plugins/uyap-plugin/store/modules/GorevYoneticisiTypes";
import {store} from "@/store";
import {promptForPin} from './utils/pin-modal';

const imzaciUrl = 'https://imza.eicrapro.com:6090/'
const proxyBaseUrl = 'https://imza.eicrapro.com:';
const avukatUyapUrl = 'https://imza.eicrapro.com:6081';
// Yeni imzalama uygulaması (localhost:5975) proxy adresi
const newSignerUrl = 'https://imza.eicrapro.com:6075';

export enum UYAP_PLATFORM_SOCKET {
    ARABULUCU_PORTAL = 6080,
    ARABULUCU_PORTAL_URL = "arabulucu.uyap.gov.tr",
    AVUKAT_PORTAL = 6081,
    AVUKAT_PORTAL_URL = "avukat.uyap.gov.tr",
}

class ImzaClient {
    simulator = false;
    availableCardsPromise: Promise<any>|null = null;
    betaLoginPromise: Promise<any>|null = null;

    private ensureTcknInSession(): string | null {
        let t = sessionStorage.getItem('tckn');
        const isValid = (val: any) => typeof val === 'string' && /^\d{11}$/.test(val);
        if (!isValid(t)) {
            try {
                const s = store?.getters?.userData?.kimlik_no;
                if (isValid(String(s))) {
                    t = String(s);
                    sessionStorage.setItem('tckn', t);
                } else {
                    t = null;
                }
            } catch (_e) {
                t = null;
            }
        }
        return t;
    }

    setSimulator() {
        this.simulator = true;
    }

    heartbeat() {
        console.log('heartbeat() fonksiyonu başlatıldı');
        const xml = '<root><auth><token></token><hash></hash></auth><data></data></root>';
        return new Promise(async (s, f) => {
            if (this.simulator) {
                return s("");
            }
            try {
                let data = await axios.post(imzaciUrl + 'xml/heartbeat', {xml: xml}, {
                    withCredentials: true
                });
                return s(data);
            } catch (e) {
                //console.log('fail');
                return f(e);
            }
        });
    }
    async setApiCookiesToImza(){
        try{
            let tenant = await store.dispatch('tenantData');
            let apiType: string = "";
            switch (process.env.VUE_APP_API_TARGET) {
                case 'http://localhost':
                    apiType = "local";
                    break;
                case 'http://localhost:4000':
                    apiType = "local";
                    break;
                case 'https://apicloudicra.neova.com.tr':
                    apiType = "neova";
                    break;
                case 'https://apicloudtest.zirve-bilgisayar.com':
                    apiType = "test"
                    break;
                case 'https://apibeta.zirve-bilgisayar.com':
                    apiType = "beta"
                    break;
                case 'https://apicloud.zirve-bilgisayar.com':
                    apiType = "canli"
                    break;
                default:
                    apiType = "local";
                    break;
            }

            // Session storage'a TCKN'yi kaydet (imza doğrulama için)
            if (store.getters.userData && store.getters.userData.kimlik_no) {
                sessionStorage.setItem('tckn', store.getters.userData.kimlik_no);
                console.log('TCKN sessionStorage\'a kaydedildi:', store.getters.userData.kimlik_no);
            }

            const cookieSetUrl = encodeURI(proxyBaseUrl + UYAP_PLATFORM_SOCKET.AVUKAT_PORTAL + '/setConfig?token=' + 'Bearer ' + store.getters.accessToken + '&tenant=' + JSON.stringify(tenant) + '&tckn=' + store.getters.userData.kimlik_no + '&apiType=' + apiType);
            await app.$uyap.SetCookie().run({url: cookieSetUrl});
            _Vue.prototype.$socket.client.emit("updateToken");
            return true;
        }catch (e) {
            throw new Error(e);
        }
    }


    async setCookieToImza() {
        if (window.sessionStorage.hasOwnProperty("INJECT_JSESSIONID")) {
            let jsessionId = window.sessionStorage.getItem("INJECT_JSESSIONID");
            const cookieSetUrl = proxyBaseUrl + UYAP_PLATFORM_SOCKET.AVUKAT_PORTAL.toString() + '/cookie?JSESSIONID=' + jsessionId + ';SameSite=None;Secure';
            await app.$uyap.SetCookie().run({url: cookieSetUrl});
        }
    }

    async changePlayerStatus(status: PlayerDurum) {
        const cookieSetUrl = proxyBaseUrl + UYAP_PLATFORM_SOCKET.AVUKAT_PORTAL.toString() + '/putTaskPlayerStatus?' + status;
        await app.$uyap.ChangePlayerStatus().run({url: cookieSetUrl});
    }

    async getPlayerStatus() {
        const cookieSetUrl = proxyBaseUrl + UYAP_PLATFORM_SOCKET.AVUKAT_PORTAL.toString() + '/getTaskPlayerStatus';
        return await app.$uyap.ChangePlayerStatus().run({url: cookieSetUrl});
    }

    sendImzaMessage(msg: any){
        _Vue.prototype.$socket.client.emit("imzaMessage",msg);
    }

    async availableCards(){
        try{
            if (this.availableCardsPromise) {
                return this.availableCardsPromise;
            }
            this.availableCardsPromise = (async () => {
                try {
                    // Tek istek. Önceden ayrıca bir "imzalama uygulaması ayakta mı"
                    // yoklaması vardı ve aynı ucu ikinci kez çağırıyordu; kart bir kez
                    // kullanıldıktan sonra bu uç ~4 sn sürdüğü için her tazeleme boşuna
                    // iki katına çıkıyordu. Uygulama kapalıysa zaten bu istek patlar.
                    let certsResponse;
                    try {
                        certsResponse = await axios.get(newSignerUrl + '/api/v1/signature/getCertificates');
                    } catch (e) {
                        // "program" kelimesi korunmalı: store'daki availableCards action'ı
                        // kart bulununca bu metni 'kart'/'imzacı'/'program' geçen mesajlara
                        // bakarak temizliyor.
                        throw new Error("E-İmza Programı açık değil veya hata oluştu, lütfen e-İmza Programını açınız.");
                    }
                    const responseData = certsResponse.data;

                    if (!responseData?.data || !Array.isArray(responseData.data)) {
                        throw new Error('Sertifika listesi alınamadı.');
                    }

                    // Her terminal için sertifikaları düzleştir
                    const cardList: any[] = [];
                    for (const terminal of responseData.data) {
                        if (!Array.isArray(terminal.certificates)) continue;
                        for (const cert of terminal.certificates) {
                            cardList.push({
                                // Eski yapıyla uyumluluk için sarmalayıcı
                                terminal: terminal.terminal,
                                serialNumber: terminal.serialNumber,
                                certificate: cert
                            });
                        }
                    }

                    store.commit('setAvailableCardList', cardList);
                    return cardList;

                } finally {
                    this.availableCardsPromise = null;
                }
            })();

            return this.availableCardsPromise;

        }catch (e) {
            console.log("availableCards error", e);
            this.sendImzaMessage({
                title: "UYAP IMZA UYGULAMASI HATA!",
                text:  e.message,
                icon: "error",
                allowOutsideClick: false,
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Tamam'
            });
        }
    }
    getPinCodes(){
        if(localStorage.hasOwnProperty("pinCodes")){
            //@ts-ignore
            return JSON.parse(localStorage.getItem("pinCodes"));
        }else{
            this.setPinCodes([]);
            return [];
        }
    }
    setPinCodes(val: any){
        localStorage.setItem("pinCodes",JSON.stringify(val));
    }
    /**
     * @param sessiz Otomatik (arka plan) deneme. Hata modalı açılmaz; hata yine
     *               fırlatılır ve çağıran durumu kullanıcıya kendi yüzeyinde gösterir.
     *               Güvenlik uyarısı olan "İzinsiz İmza" sessiz modda da gösterilir.
     */
    async betaLogin(sessiz: boolean = false) {
        console.log("this.betaLoginPromise",this.betaLoginPromise);
        // Eğer zaten çalışıyorsa mevcut Promise’i döndür
        if (this.betaLoginPromise) {
            return this.betaLoginPromise;
        }
        // Fonksiyonun gerçek işini yapan Promise'i oluştur
        this.betaLoginPromise = (async () => {
            try {
                let cardList = await this.availableCards();
                if (!Array.isArray(cardList) || cardList.length === 0) {
                    throw new Error("Takılı akıllı kart bulunamadı.");
                }
                const preferredSerial: string | null = store.getters.selectedCardSerial ?? null;
                // Yeni yapıda kart kimliği certificate.certificateId
                let card = cardList.find((c: any) => c?.certificate?.certificateId === preferredSerial);
                if (!card) {
                    // Seçim yoksa körlemesine cardList[0] almak yanlış avukatın
                    // kartıyla giriş demek; TCKN elde varken önce onunla eşleştir.
                    const hesapTckn = this.ensureTcknInSession()?.replace(/\D/g, '') ?? null;
                    if (hesapTckn) {
                        card = cardList.find(
                            (c: any) => (c?.certificate?.subjectSerial ?? '').replace(/\D/g, '') === hesapTckn
                        );
                    }
                }
                if (!card) {
                    if (cardList.length > 1) {
                        throw new Error(
                            'Birden fazla e-imza kartı takılı ve hesabınıza ait olan belirlenemedi. ' +
                            'Üst menüden kullanmak istediğiniz kartı seçiniz.'
                        );
                    }
                    card = cardList[0];
                }
                store.commit('setSelectedCardSerial', card.certificate.certificateId);
                await axios.post('https://imza.eicrapro.com:6090/focus');

                // TCKN kontrolü - yeni yapıda subjectSerial düz metin (base64 değil)
                const certTcknRaw: string = card.certificate.subjectSerial ?? '';
                console.log('Beta Login - Sertifika TCKN:', certTcknRaw);
                const sessionTcknRaw = this.ensureTcknInSession();
                console.log('Beta Login - SessionStorage TCKN:', sessionTcknRaw);

                const normalize = (v: string | null | undefined) => v ? v.replace(/\D/g, '') : null;
                const sessionTckn = normalize(sessionTcknRaw);
                const certTckn = normalize(certTcknRaw);
                console.log("certTckn", certTckn);

                if (sessionTckn && certTckn && sessionTckn !== certTckn) {
                    console.error('TCKN uyuşmazlığı! SessionStorage:', sessionTckn, 'Sertifika:', certTckn);
                    throw {type: 'unauthorized', message: 'İzinsiz İmza'};
                } else if (!sessionTckn) {
                    console.warn('SessionStorage\'da TCKN bulunamadı, kontrol atlanıyor');
                } else {
                    console.log('TCKN kontrolü başarılı');
                }

                let pinCodes = this.getPinCodes();
                // Yeni yapıda seri no: certificate.certificateId (düz metin)
                const currentSerial = card.certificate.certificateId;
                console.log("currentSerial", currentSerial);
                let cardPin = pinCodes.find((item: any) => item.cardSerialNumber === currentSerial);
                console.log("cardPin", cardPin);

                let pinCode: string;
                if (!cardPin) {
                    const formValues = await promptForPin({
                        ownerName: card.certificate.subject,
                        title: 'İmza Pin Kodu',
                        rememberLabel: 'Otomatik oturum aç',
                        minLen: 4,
                        maxLen: 12
                    });

                    if (!formValues) {
                        throw new Error('İmza işlemi iptal edildi');
                    }

                    pinCode = formValues.pin;
                    const autoLoginEnabled = formValues.remember;

                    console.log('Otomatik oturum aç:', autoLoginEnabled);

                    pinCodes.push({
                        cardOwnerName: card.certificate.subject,
                        cardSerialNumber: currentSerial,
                        pinCode: pinCode,
                        autoLogin: autoLoginEnabled
                    });
                    this.setPinCodes(pinCodes);
                } else {
                    pinCode = cardPin.pinCode;
                }

                // UYAP sabit challenge metni (HAR'dan alındı)
                const UYAP_SIGN_CONTENT = 'QWRhbGV0IEJha2FubMSxxJ/EsSBCaWxnaSDEsMWfbGVtIEdlbmVsIE3DvGTDvHJsw7zEn8O8IHRhcmFmxLFuZGFuIGdlbGnFn3RpcmlsZW4gdXlndWxhbWF5YSBlLWltemEgZ2lyacWfIHlhcG1hayBpc3RpeW9ydW0u';

                // Yeni imzalama uygulaması ile imzala
                let signResponse: any;
                try {
                    signResponse = await axios.post(newSignerUrl + '/api/v1/signature/sign', {
                        certificateId: card.certificate.certificateId,
                        password: pinCode,
                        content: UYAP_SIGN_CONTENT
                    });
                } catch (e) {
                    // PIN hatası kontrolü
                    if (e?.response?.status === 401 || e?.response?.data?.metadata?.STATUS === 'WRONG_PIN') {
                        pinCodes = pinCodes.filter((item: any) => item.cardSerialNumber !== currentSerial);
                        this.setPinCodes(pinCodes);
                        throw {type: 'pin', message: 'PIN Yanlış', serialNumber: currentSerial};
                    }
                    throw e;
                }

                const signedData = signResponse?.data?.data?.signedData;
                const txId = signResponse?.data?.data?.txId;
                if (!signedData || !txId) {
                    throw new Error('İmzalama başarısız: İmzalanmış veri veya txId alınamadı.');
                }

                // HAR'a göre: GET web1.uyap?signature=...&txId=...
                let newAxios = new Axios({
                    withCredentials: true,
                });
                await newAxios.get(avukatUyapUrl + '/clearCookies');
                const web1Res = await newAxios.get(avukatUyapUrl + '/web1.uyap', {
                    params: {
                        signature: signedData,
                        txId: txId
                    }
                });
                window.sessionStorage.setItem("JSESSIONID", web1Res.headers.cookie ?? '');

                await newAxios.post(avukatUyapUrl + '/login.uyap', {});
                await axios.post('https://imza.eicrapro.com:6090/focus');
                this.betaLoginPromise = null;
            } catch (e) {
                // eslint-disable-next-line no-console
                console.log("ERROR", e);
                if (e?.type == "unauthorized") {

                    this.sendImzaMessage({
                        title: "İzinsiz İmza",
                        text:  "Hesabınızda kayıtlı TC kimlik numarası ile e-İmza kartındaki TC kimlik numarası uyuşmamaktadır. Lütfen kendi hesabınızla giriş yapın ve size ait e-İmza kartını kullanın. Sorunun devam ettiğini düşünüyorsanız, Cloud ekranında Ctrl + Shift + R tuşlarına basarak sayfayı yenileyebilir ve tekrar deneyebilirsiniz.",
                        icon: "warning",
                        allowOutsideClick: false,
                        confirmButtonColor: '#3085d6',
                        confirmButtonText: 'Tamam'
                    });

                } else if (sessiz) {
                    // Otomatik (arka plan) deneme: kullanıcı bir şey istemedi, modal
                    // açmak rahatsız edici olur. İzinsiz İmza bunun dışında — o bir
                    // güvenlik uyarısı ve kullanıcının görmesi gerekiyor (yukarıda).
                    // Hata yine fırlatılıyor; durum kartına ve loga düşüyor.
                } else if (e.message && e.message.includes("Failed to execute 'atob'")) {
                    this.sendImzaMessage({
                        title: "İmza Kartı Bulunamadı",
                        text:  "İmza kartının bilgisayara takılı olduğundan ve sürücülerinin yüklü olduğundan emin olun.",
                        icon: "warning",
                        allowOutsideClick: false,
                        confirmButtonColor: '#3085d6',
                        confirmButtonText: 'Tamam'
                    });
                } else {
                    this.sendImzaMessage({
                        title: "UYAP oturumu açılırken bir hata oluştu.",
                        text:  e.message,
                        icon: "error",
                        allowOutsideClick: false,
                        confirmButtonColor: '#3085d6',
                        confirmButtonText: 'Tamam'
                    });
                }
                // Hata YUTULMAZ. Eskiden burada throw yorum satırındaydı: giriş
                // başarısız olsa bile promise resolve ediyor, connectToUyap durumu
                // ancak arkasından gelen loadUyapMetaData patlayınca fark ediyordu.
                // Otomatik giriş akışı ise "başarılı" sanıp geri çekilmeyi hiç
                // uygulamayacaktı.
                throw e instanceof Error ? e : new Error(e?.message ?? String(e));
            } finally {
                // İşlem bittiğinde lock’u sıfırla
                this.betaLoginPromise = null;
            }
        })();
        // Promise’i döndür
        return this.betaLoginPromise;
    }

    /** Kartın PIN'i kayıtlı mı. Otomatik giriş yalnızca kayıtlıysa denenir. */
    kartPinKayitliMi(cardSerialNumber: string | null): boolean {
        if (!cardSerialNumber) {
            return false;
        }
        const kayit = this.getPinCodes().find((item: any) => item.cardSerialNumber === cardSerialNumber);
        return Boolean(kayit?.pinCode) && kayit?.autoLogin !== false;
    }

    mesajImzala() {
        const myXml = '<root>' +
            '<auth><token></token></auth>' +
            '<data><message>Emre deneme imzala</message></data>' +
            '</root>';
        //readResult = reader.result.split(',')[1];
        axios.post(imzaciUrl + "xml/mesajImzala", myXml, {
            headers: {
                "Content-Type": "application/xml;charset=UTF-8"
            }
        })
    }



    icrapro80VeriAktar(dosyaEsasNo: any, icraDairesi: any, kartId: any, klasor: any) {
        return new Promise((resolve, reject) => {
            const xml = "<dosyaEsasNo>" + dosyaEsasNo + "</dosyaEsasNo><icraDairesi>" + icraDairesi + "</icraDairesi><kartId>" + kartId + "</kartId><icraproKlasor>" + klasor + "</icraproKlasor>";
            let myXml = "<root>\n" +
                "<auth>\n" +
                "<token></token>\n" +
                "<hash></hash>\n" +
                "</auth>\n" +
                "<data>\n" +
                "<b64Xml>" + Mixins.utf8_to_b64(xml) + "</b64Xml>\n" +
                "</data>\n" +
                "</root>"
            axios.post(imzaciUrl + 'xml/setDosyaEsasNo', myXml, {
                headers: {
                    "Content-Type": "application/xml;charset=UTF-8"
                }
            }).then((data) =>{
                return resolve(data)
            }).catch((err)=>{
                return reject(err);
            });
        })
    }

    dokumanImzala(data: Blob) {
        return new Promise((resolve, reject) => {
            if (this.simulator) {
                resolve("");
                return;
            }
            const reader = new FileReader();
            reader.readAsDataURL(data); //udf base64 ceviriliyor..
            reader.onloadend = function () {
                //console.log("reader Result",reader.result);
                let b64Udf;
                if (typeof reader.result == "string") {
                    b64Udf = reader.result.split(',')[1];
                } else {
                    return reject('Dosya okunurken hata oluştu');
                }
                //console.log("b64UDF", b64Udf);

                //127.0.0.1:4723/xml/dokumanImzala
                //* blob data reader ile base 64 e ceviriliyor imzaciya gonderiliyor...

                const myXml = '<root>' +
                    '<auth><token></token></auth>' +
                    '<data><code>' + b64Udf + '</code></data>' +
                    '</root>';
                //readResult = reader.result.split(',')[1];
                axios.post(imzaciUrl + "xml/b64imzala", myXml, {
                    headers: {
                        "Content-Type": "application/xml;charset=UTF-8"
                    }
                }).then((data) => {
                    let parseString = xml2js.parseString;
                    parseString(data.data, {explicitArray: false}, (error: Error | null, result: any) => {
                        if (error) {
                            return reject(error);
                        }
                        //console.log("RESULT IMZALANMA", result);
                        return resolve(result.root.file);
                    });
                }).catch(function (err) {
                    if (err.response) {
                        let parseString = xml2js.parseString;
                        parseString(err.response.data, {explicitArray: false}, (error: Error | null, result: any) => {
                            app.$toast.error("Hata Kodu " + err.response.status + ": " + result.root.error_title);
                        });
                    } else if (err.request) {
                        app.$toast.error("İmzacı bağlantı hatası.");
                    } else {
                        app.$toast.error("Bilinmeyen hata (" + err.message + ")");
                    }
                    return reject(err);
                });

            };
        });
    }

    getFileFromLocalPath(path: string) {
        return new Promise((resolve, reject) => {
            let myXml = "<root>\n" +
                "<auth>\n" +
                "<token></token>\n" +
                "<hash></hash>\n" +
                "</auth>\n" +
                "<data>\n" +
                "<b64Xml>" + Mixins.utf8_to_b64("<path>" + path + "</path>") + "</b64Xml>\n" +
                "</data>\n" +
                "</root>"
            axios.post(imzaciUrl + "xml/getXmlContent", myXml, {
                headers: {
                    "Content-Type": "application/xml;charset=UTF-8"
                }
            }).then((data) => {
                let replacedData = String(data.data).replace(/\n/g, "");
                let parseString = xml2js.parseString;
                parseString(replacedData, {explicitArray: false}, (error: Error | null, jsonData: any) => {
                    if (error) {
                        return reject(error);
                    }
                    if (typeof jsonData.root.file != "undefined") {
                        return resolve(jsonData.root);
                    } else {
                        return reject({message: "Dosya bulunamadı !"});
                    }
                });
            }).catch(err => {
                return reject(err);
            })
        });
    }

    serialize(obj: any) {
        let str = [];
        for (let p in obj)
            if (obj.hasOwnProperty(p)) {
                str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
            }
        return str.join("&");
    }

}

export default function ImzaClientPlugin(Vue: typeof _Vue): void {
    // do stuff with options
    Vue.prototype.$imza = new ImzaClient();
}
